import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {Utils} from "../../js/utils";

export class ModHeader extends ModuleComponent{

    getParameterByName(name){
        name = name.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");
        var regex = new RegExp("[\\?&]"+name+"=([^&#]*)"),
            results = regex.exec(location.search);
        return results===null?"":decodeURIComponent(results[1].replace(/\+/g," "));
    }

    showMegaMenu(ev){
        const itemIndex = $(ev.currentTarget).data("item");
        const $allMegamenus = this.findMember("megamenu");
        const $selectedMegamenu = $allMegamenus.filter(".is-item-"+itemIndex);

        // Mostrar el menú seleccionado
        this.findMember("main-menu-a").removeClass("is-active");
        $allMegamenus.removeClass("is-active");
        $(ev.currentTarget).addClass("is-active");
        $selectedMegamenu.addClass("is-active");
        $selectedMegamenu.find(this.scope+"__megamenu-sidebar-li-a").eq(0).click();
        if($(ev.currentTarget).hasClass("js-mod-header__main-menu-have-subitem")){
            GvfService.cancelDelay("megamenu-to-hidden");
            this.$root.addClass("is-megamenu-selected");
        }
    }

    updateIsScrolling(){
        if(window.scrollY>1){
            this.$root.addClass("is-scrolling");
        }else{
            this.$root.removeClass("is-scrolling");
        }
    }

    updateIsSmall(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if(scrollTop<this.lastScrollTop){
            this.$root.removeClass("is-small");
        }else{
            this.$root.addClass("is-small");
        }
        this.lastScrollTop = scrollTop;
    }

    ready(){
        super.ready();
        this.lastScrollTop = 0;

        //TO DELETE
        if(this.$root.data("header-type")==="is-white"){
            this.$root.addClass("is-white");
        }

        /* SCROLLING */
        window.addEventListener("scroll",() => {
            this.updateIsScrolling();
        });

        /* SMALL */
        window.addEventListener("scroll",() => {
            this.updateIsSmall();
        });

        this.findMember("opener").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.toggleClass("is-opened");
                $("body").toggleClass("web-no-scroll");
            }
        );

        /*MENU LANGUAGE OPEN*/
        this.findMember("language").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.toggleClass("is-menu-language-opened ");
                $("body").toggleClass("web-no-scroll");
            }
        );

        /*MENU LANGUAGE CLOSE*/
        this.findMember("menu-language-close").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                $("header").toggleClass("is-menu-language-opened");
                $("body").removeClass("web-no-scroll");
            }
        );

        /*MENU USER OPEN*/
        this.findMember("user").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.toggleClass("is-menu-user-opened ");
                $("body").toggleClass("web-no-scroll");
            }
        );

        /*MENU USER CLOSE*/
        this.findMember("menu-user-close").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                $("header").toggleClass("is-menu-user-opened");
                $("body").removeClass("web-no-scroll");
            }
        );

        this.findMember("menu-user-overlay").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                $("header").toggleClass("is-menu-user-opened");
                $("body").removeClass("web-no-scroll");
            }
        );

        this.findMember("search-close").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.removeClass("is-showing-search");
            }
        );

        this.findMember("search-box-overlay").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.removeClass("is-showing-search");
            }
        );

        this.findMember("search-btn-view").click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.addClass("is-showing-search");
            }
        );

        this.findMember("main-menu-a").on("mouseenter",(ev) => {
            this.showMegaMenu(ev);
        });

        this.findMember("main-menu-a").on("mouseleave",(ev) => {
            GvfService.cancelDelay("megamenu-to-hidden");
            const itemIndex = $(ev.currentTarget).data("item");
            const $allMegamenus = this.findMember("megamenu");
            const $selectedMegamenu = $allMegamenus.filter(".is-item-"+itemIndex);
            $(ev.currentTarget).removeClass("is-active");
            $selectedMegamenu.removeClass("is-active");
            this.$root.removeClass("is-megamenu-selected");
        });

        this.findMember("megamenu-sidebar-li-a").click(
            (ev) => {
                ev.preventDefault();
                const subitemIndex = $(ev.currentTarget).data("subitem");
                this.findMember("megamenu-sidebar-li-a").removeClass("is-active");
                $(ev.currentTarget).addClass("is-active");
                this.findMember("megamenu-content").removeClass("is-active").filter(".is-subitem-"+subitemIndex).addClass("is-active");
            }
        );

        this.findMember("mobile-menu-a").click(
            (ev) => {
                const $link = $(ev.currentTarget);
                const $currentMenu = $link.closest(this.scope+"__mobile-menu-ul");
                const $nextMenu = this.findMember("mobile-menu-ul").filter(".is-menu-"+$link.data("target"));
                if($nextMenu.length>0){
                    ev.preventDefault();
                    $nextMenu.addClass("is-opening");
                    GvfService.delay(500).then(() => {
                        $currentMenu.removeClass("is-opened");
                        $nextMenu.removeClass("is-opening").addClass("is-opened");
                    });
                }
            }
        );

        this.findMember("logout").click(
            (ev) => {
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web-user-private/logout",
                    {}
                ).then(
                    (resp) => {
                        window.location = resp.url;
                    }
                ).catch(Utils.alertEndpointResponse);
            });

        this.findMember("megamenu").mouseover((ev) => {
            let isItem = $(ev.currentTarget).data('is-item');
            GvfService.cancelDelay("megamenu-to-hidden");
            this.$root.addClass("is-megamenu-selected");
            $(ev.currentTarget).addClass("is-active");
            this.findMember('main-menu-a').filter((index,ev)=>$(ev).data('item') === isItem).addClass('is-active');
        });
        this.findMember("megamenu").mouseleave((ev) => {
            GvfService.cancelDelay("megamenu-to-hidden");
            GvfService.delay(200,"megamenu-to-hidden").then(() => {
                this.$root.removeClass("is-megamenu-selected");
                this.findMember('main-menu-a').removeClass('is-active');
                $(ev.currentTarget).removeClass("is-active");
            });
        });
    }
}